export default __webpack_public_path__ + "2f3d3ec73e79f7a075614bf536ddcd65.svg";